import { CreateTicketComponent } from "./create/create.ticket.component";
import { EditTicketComponent } from "./edit.ticket.component";
import { ViewTicketComponent } from "./view/view.ticket.component";

export const TicketsRouting = [
    { path: '', redirectTo: 'view-ticket', pathMatch: 'full' },
    { path: 'create-ticket', component: CreateTicketComponent },
    { path: 'edit-ticket', component: EditTicketComponent },
    { path: 'view-ticket', component: ViewTicketComponent },
]

export const TickesBreadCrumbs = [
    { name: 'Create-ticket', path: '/create-ticket' },
    { name: 'Edit-ticket', path: '/edit-ticket' },
    { name: 'View-ticket', path: '/view-ticket' },
]